const { __ } = wp.i18n;

jQuery( document ).ready( function( $ ) {
	// Ledyer checkout.
	const $ledyerBtn = $( '.ledyer-checkout-select-other-wrapper' );
	if ( $ledyerBtn.length > 0 ) {
		$ledyerBtn.find( '.checkout-button' ).text( __( 'Byt till privatperson', 'boldlabels' ) );
		$ledyerBtn.prependTo( '#lco-iframe' );
		$ledyerBtn.show();
	}

	// Klarna checkout.
	const $klarnaBtn = $( '.klarna-checkout-select-other-wrapper' );
	if ( $klarnaBtn.length > 0 ) {
		$klarnaBtn.find( '.checkout-button' ).text( __( 'Byt till företag', 'boldlabels' ) );
		$klarnaBtn.prependTo( '#kco-iframe' );
		$klarnaBtn.show();
	}
} );
